<template>
    <div class="vod-view" ref="view">
        <VodSidebar />
        <VodNavigation v-if="!isMobile" />
        <div class="vod-content" v-if="!appLoading">
            <transition name="fade" mode="out-in">
                <router-view @scroll="scrollTo" :key="$route.path" />
            </transition>
        </div>
        <VodFooter v-if="!isMobile" />
        <transition name="fade">
            <AppLoading v-if="appLoading"></AppLoading>
        </transition>
    </div>
</template>
<script>
import VodSidebar from './VodSidebar'
import VodNavigation from './VodNavigation'
import VodFooter from './VodFooter'
import AppLoading from '@/components/utils/AppLoading'
export default {
    components: {
        VodNavigation,
        VodSidebar,
        VodFooter,
        AppLoading
    },
    data() {
        return {
            appLoading: true
        }
    },
    computed: {
        isMobile() {
            return this.$store.getters['source/isMobile']
        },
        jwt() {
            return this.$query.getQuery('jwt')
        },
        currentAccount() {
            return this.$store.state.user
        }
    },
    methods: {
        scrollTo() {
            this.$refs.view.scrollTop = this.$refs.view.scrollHeight
        },
        setHeaders() {
            const jwt = this.jwt ? this.jwt : ''
            this.$Network.setHeaders(this, jwt)
        },
        getUser() {
            if (!this.jwt && !this.currentAccount.mail) {
                this.appLoading = false
                return
            }
            this.setHeaders()
            this.$apiService
                .getAccount()
                .then(data => {
                    this.$i18n.locale = 'pl'
                    data.display = `${data.name} ${data.surname}`
                    data.account_id = data.id
                    this.$store.commit('setUser', data)
                    this.$query.removeQuery('jwt')
                    this.goToPendingWebinar()
                    this.getBoughtItems()
                    this.$apiService.getStorage()
                })
                .catch(error => {
                    this.$router.push('/')
                    this.$store.commit('resetState')
                    this.$Network.handleError(error)
                    this.appLoading = false
                })
        },
        goToPendingWebinar() {
            const pendingWebinar = this.$store.state.pendingTransactionWebinar
            const pendingCourse = this.$store.state.pendingTransactionCourse
            if (pendingWebinar || pendingCourse) {
                const url = pendingWebinar
                    ? `/webinar/${pendingWebinar}`
                    : `/course/${pendingCourse}`
                this.$nextTick(() => {
                    this.$router.push(`${url}?transaction=true`)
                    this.$store.commit('setPendingTransactionWebinar', '')
                    this.$store.commit('setPendingTransactionCourse', '')
                })
            }
        },
        getBoughtItems() {
            this.$apiService
                .getBoughtItems()
                .catch(error => {
                    this.$router.push('/')
                    this.$store.commit('resetState')
                    this.$Network.handleError(error)
                })
                .then(() => {
                    this.appLoading = false
                })
        }
    },
    mounted() {
        this.getUser()
        this.$store.dispatch('source/checkQuery')
    },
    watch: {
        $route() {
            this.$refs.view.scrollTop = 0
        }
    }
}
</script>
